import { Pipe, PipeTransform } from '@angular/core';


@Pipe( {
    name: 'timeFromString'
} )

export class TimeFromStringPipe implements PipeTransform {
    transform(time: string, format: string = ''): string {

        switch (format) {
            case 'hh':
                // 12:34:00 --> 12
                return time.substring(0, 2);
            case 'mm':
                // 12:34:00 --> 34
                return time.substring(3, 5);
            case 'hh:mm':
                // 12:34:00 --> 12:34
                return time.substring(0, 5);
            default:
                return time;
        }
    }
}
